<app-navtop></app-navtop>
<app-navside-apps-list></app-navside-apps-list>
<app-navside-sponsor></app-navside-sponsor>



<div class="container pt-5">
    <div class="d-flex flex-row bd-highlight">
        <div class="col-lg-6 col-md-8 p-2 mx-xl-auto mx-lg-auto ml-md-auto content-main">                        
            <div class="list-group my-3">
                <div class="list-group-item list-group-item-action" disable>
                    <h2>Popular Business</h2> 
                </div>
                <a class="list-group-item list-group-item-action" 
                *ngFor="let item of items | async"    
                (click)="routeToBusinessDetailsPage(item.id)" routerLink="">                
                    <div class="media">                        
                        <img *ngIf="!item.profilePictureUrl" [src]="logoImage" class="mr-3 align-self-center rounded-circle image" alt="...">
                        <img *ngIf="item.profilePictureUrl" [src]="item.profilePictureUrl" class="mr-3 align-self-center rounded-circle image" alt="...">
                        <div class="media-body">
                            <!-- <h2>{{ item.name }}</h2> -->
                            <div class="h5 m-0">{{ item.name }}</div>
                            <p class="badge badge-dark p-1">{{item.category}}</p>
                            <p>{{item.phone}}
                                <span *ngIf="item.phone && item.email">|</span> 
                                {{item.email}} 
                                <!-- <span *ngIf="item.email && item.websiteUrl">|</span> 
                                {{item.websiteUrl}} -->
                            </p>                            
                        </div>       
                    </div>                
                </a>     
            </div>
            
            <div class="list-group my-3">
                <li class="list-group-item list-group-item-action" disable>
                    <h2>Popular Business Category</h2>
                </li>
                <a class="list-group-item list-group-flush" 
                    (click)="routeToBusinessListPage(item.name)" routerLink=""
                    *ngFor="let item of catItems | async; let i = index">                
                    <div class="media p-2">
                        <div class="media-body">
                            <h3 class="float-left">{{ item.name }}</h3>
                            <span class="float-right font-weight-bold">
                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>
                                  </svg>
                            </span>
                        </div>
                    </div>                
                </a>     
            </div>
            <button type="button" (click)="routeToBusinessCategoryListPage()"
                class="btn btn-warning btn-lg btn-block my-3 px-4">
                <span class="float-left">View All Business Category</span>
                <span class="float-right font-weight-bold">
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                        <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>
                      </svg>
                </span>                
            </button>
        </div>
    </div>
</div>
